import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  card: {
    padding: theme.spacing(2.25, 2.5),
    borderRadius: 12,
    background: theme.palette.background.paper,
    boxShadow: theme.palette.mode === "light"
      ? "0 1px 4px rgba(0,0,0,0.08)"
      : "0 1px 4px rgba(0,0,0,0.4)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  titleGroup: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: 20,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
  },
  subtitle: {
    fontSize: 12.5,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
}));

const SettingsCard = ({ icon: Icon, title, subtitle, action, children }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <div className={classes.titleGroup}>
          {Icon && <Icon className={classes.icon} />}
          <div className={classes.title}>{title}</div>
        </div>
        {action}
      </div>
      {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
      {children}
    </div>
  );
};

export default SettingsCard;
